import React from "react";
import { TECHS } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function TechGrid() {
  return (
    <section id="tech" data-testid="tech-grid" className="relative py-12 md:py-16 border-y border-line">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>Our toolbox</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            The technologies we <span className="text-gradient">master</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7 xl:grid-cols-8 gap-3 md:gap-4">
          {TECHS.map((t, i) => {
            const Icon = t.icon;
            return (
              <Reveal key={t.name} delay={(i % 8) * 0.04}>
                <div
                  data-testid={`tech-${t.name.toLowerCase().replace(/[^a-z0-9]/g, "")}`}
                  className="group flex flex-col items-center justify-center gap-2 rounded-xl glass py-4 hover:border-brand/50 transition-all duration-300 hover:-translate-y-1"
                >
                  <Icon size={24} className="text-textsub group-hover:text-brand transition-colors duration-300" />
                  <span className="text-xs text-textsub group-hover:text-textmain transition-colors">{t.name}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
